import React, { useContext, useEffect } from "react";
import "../styles/basket.css";
import appConst from "../Utilities/appConst.json";
import BasketItemTile from "../Components/BasketItemTile";
import BasketItemOrdersUnion from "../Components/BasketItemOrdersUnion";
import BasketItemBooks from "../Components/BasketItemBooks";
import BasketItemMosaic from "../Components/BasketItemMosaic";
import BasketItemCalendar from "../Components/BasketItemCalendar";
import { getUiItemFilterPrefix } from "../Utilities/itemFilter";

const BasketItem = ({ item, setSelectedValue, product, isDeletionMode }) => {
  const isMosaic = (item) => {
    return item.format.toString().startsWith(appConst.MOSAIC_FORMAT_PREFIX);
  };

  const commonProps = {
    item: item,
    id: item.item_id,
    setSelectedValue: (e) => setSelectedValue(e, item.item_id, item.quantity),
    isChecked: item.isChecked,
    product: product,
    isDeletionMode: isDeletionMode,
  };

  switch (product) {
    case appConst.TILES:
      return !isMosaic(item) ? (
        <BasketItemTile {...commonProps} />
      ) : (
        <BasketItemMosaic {...commonProps} />
      );
    case appConst.ORDERS_UNION:
      return <BasketItemOrdersUnion {...commonProps} />;
    case appConst.BOOKS:
      const itemFilterPrefix = getUiItemFilterPrefix(item?.item_filter);
      switch (itemFilterPrefix) {
        case appConst.VERSION_TREE_V1_PREFIX: // online
          return <BasketItemBooks {...commonProps} />;
        case appConst.VERSION_TREE_V3_PREFIX: // app
          return <BasketItemBooks {...commonProps} />;
        case appConst.VERSION_CALENDAR_PREFIX:
          return <BasketItemCalendar {...commonProps} disabled={true} />;
        default:
          return <BasketItemBooks {...commonProps} disabled={true} />;
      }
    case appConst.CALENDARS:
      return <BasketItemCalendar {...commonProps} />;
    default:
      return null; // handle other cases or provide a default component
  }
};

export default BasketItem;
